import React from "react";
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div className="items-center">
        <footer className="foot flex justify-between items-center w-full px-4 py-1">
            <div className="flex items-center space-x-2">
                <img
                    src="/images/OneHumLogoLightSmall.png"
                    alt="onehum logo"
                    className="flogo2 py-1 inline-block"
                />
                <span className="font-normal text-xl text-white">|</span>
                <img
                    src="/images/A360Logo.png"
                    alt="Acuitas 360 logo"
                    className="flogo pb-0.5 pt-1.5 inline-block"
                />
            </div>
            <p className="text-gray-100 text-xs">
                © {year} Acuitas360 LLC. All rights reserved
            </p>
        </footer>
    </div>
  );
};

export default Footer;
